<template>
  <div class="accountListBody">
    <el-col>
      <el-form :inline="true" :model="onceSearch" class="demo-form-inline">
        <el-form-item label="登录账号">
          <el-input
            v-model="onceSearch.loginName"
            placeholder="请输入登录账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input
            v-model="onceSearch.nickName"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button size="medium" @click="resetSearch">重置</el-button>

          <el-button type="primary" @click="addAccountDialogVisibleFlag = true"
            >单个新增</el-button
          >
          <el-button type="primary" @click="openAutoAccountDialog()"
            >自动生成账号</el-button
          >
        </el-form-item>
      </el-form>

      <div class="tableContainer">
        <el-table
          v-loading="listLoading"
          :data="dataList"
          border
          fit
          highlight-current-row
        >
          <el-table-column
            label="账号ID"
            prop="id"
            align="center"
            width="100"
          />
          <el-table-column
            label="登录账号"
            prop="loginName"
            width="200"
            align="center"
          />
          <el-table-column
            label="用户名"
            prop="nickName"
            width="100"
            align="center"
          />
          <el-table-column
            label="关联人员"
            prop="employeeName"
            width="100"
            align="center"
          />
          <el-table-column
            label="创建时间"
            prop="createTime"
            width="200"
            align="center"
          />

          <el-table-column
            label="账号状态"
            prop="status"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status == 1 ? 'danger' : 'success'"
                class="change-state"
                @click=""
              >
                {{ statusTag[scope.row.status] }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="激活情况"
            prop="activateStatus"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.activateStatus == 1 ? 'info' : 'success'"
                class="change-state"
                @click=""
              >
                {{ statusActiveTag[scope.row.activateStatus] }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            prop="tpye"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                v-if="scope.row.status === 1"
                @click="switchStatus(scope.row)"
                >启用
              </el-button>
              <el-button
                type="text"
                size="small"
                v-if="scope.row.status === 0"
                @click="switchStatus(scope.row)"
                >禁用
              </el-button>

              <el-button
                type="text"
                size="small"
                @click="openPermissionSettings(scope.row)"
                >权限设置</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="updatePassword(scope.row)"
                >修改密码</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="initPassword(scope.row)"
                >初始化密码</el-button
              >

              <el-button
                type="text"
                size="small"
                @click="editAccount(scope.row)"
                >编辑</el-button
              >

              <el-button
                type="text"
                size="small"
                style="color: #f56c6c"
                @click="delInfoEvent(scope.row)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--页码-->
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryForm.current"
          :limit.sync="queryForm.size"
          @pagination="getAccountManageMore"
        />
      </div>
    </el-col>

    <!--新增用户-->
    <el-dialog
      title="新增用户"
      :visible.sync="addAccountDialogVisibleFlag"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addAccountForm"
        ref="addAccountForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="关联人员" prop="employeeId">
          <el-select
            v-model="addAccountForm.employeeId"
            placeholder="请选择关联人员"
            style="width: 100%"
          >
            <el-option
              v-for="item in this.relatedUserList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户姓名" prop="nickName">
          <el-input v-model="addAccountForm.nickName"></el-input>
        </el-form-item>
        <el-form-item label="登录账号" prop="loginName">
          <el-input v-model="addAccountForm.loginName"></el-input>
        </el-form-item>

        <el-form-item label="电话号码" prop="phone">
          <el-input v-model="addAccountForm.phone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm()">重置</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>

    <!--自动生成账号-->
    <el-dialog
      title="自动生成账号"
      :visible.sync="autoAccountDialogVisibleFlag"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-row type="flex" justify="space-between" style="margin-bottom: 20px">
        <el-col class="autoTxt1">
          已有用户
          {{ statisticInfo != null ? statisticInfo.existingUsersCount : 0 }} 人
        </el-col>
        <el-col class="autoTxt1">
          已生成账号
          {{ statisticInfo != null ? statisticInfo.existingAccountCount : 0 }}
          人
        </el-col>
        <el-col class="autoTxt1">
          未生成账号
          {{
            statisticInfo != null ? statisticInfo.nonExistingAccountCount : 0
          }}
          人
        </el-col>
      </el-row>

      <el-col style="" v-for="(item, index) in autoCreateSuccList" :key="index">
        <el-col v-if="item.phone == null">
          {{ item.name }} ->电话号码为空,无法创建账号
        </el-col>

        <el-col v-else-if="item.phone != null">
          {{ item.name }} ->电话号码[{{ item.phone }}]已被占用,无法创建账号
        </el-col>
      </el-col>

      <div
        style="
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <el-button type="primary" @click="autoCreate()">生成</el-button>
        <el-button @click="autoAccountDialogVisibleFlag = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>

    <!--启用、禁用弹窗-->
    <el-dialog
      :title="switchStatusInfo.status === 0 ? '禁用' : '启用'"
      :visible.sync="statusDialogVisibleFlag"
      width="30%"
    >
      <!-- 0启用 1禁用 -->
      <span
        >确定{{ switchStatusInfo.status === 0 ? '禁用' : '启用' }}
        {{ switchStatusInfo.employeeName }} 账号吗？</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="switchStatusInfoSubmit()"
          >确 定</el-button
        >
        <el-button @click="statusDialogVisibleFlag = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 修改密码 -->

    <el-dialog
      title="修改密码"
      :visible.sync="updateDialogVisibleFlag"
      :close-on-click-modal="false"
    >
      <el-form
        :model="pwdInfo"
        ref="pwdInfoForm"
        :rules="pwdRules"
        label-width="120px"
      >
        <el-form-item label="新密码" prop="pwd">
          <el-input v-model="pwdInfo.pwd"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="pwd2">
          <el-input v-model="pwdInfo.pwd2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisibleFlag = false">取 消</el-button>
        <el-button type="primary" @click="updateSubmitForm()">确 定</el-button>
      </div>
    </el-dialog>

    <!--初始化密码弹窗-->
    <el-dialog
      title="初始化密码"
      :visible.sync="initPwdDialogVisibleFlag"
      width="30%"
    >
      <span>确定初始化 {{ initPwdInfo.employeeName }} 密码吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="initPwdInfoSubmit()">确 定</el-button>
        <el-button @click="initPwdDialogVisibleFlag = false">取 消</el-button>
      </span>
    </el-dialog>

    <!--初始化密码成功 弹窗-->
    <el-dialog
      title="初始化密码成功"
      :visible.sync="initPwdSuccessDialogVisibleFlag"
      width="30%"
    >
      <span>初始化后密码：{{ pwd }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="copyTextToClipboard()"
          >复制密码</el-button
        >
        <el-button @click="initPasswordClose()">关闭</el-button>
      </span>
    </el-dialog>

    <!--删除弹窗-->
    <el-dialog
      title="删除"
      :visible.sync="delInfoDialogVisibleFlag"
      width="30%"
    >
      <span>确定删除 {{ delInfo.employeeName }} 账号吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delInfoSubmit()">确 定</el-button>
        <el-button @click="delInfoDialogVisibleFlag = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 权限配置 -->
    <el-dialog
      title="权限配置"
      :visible.sync="permissionSettingsDialogVisibleFlag"
      width="50%"
      height="80%"
      :close-on-click-modal="false"
    >
      <el-row type="flex" justify="space-between" style="margin-bottom: 20px">
        <el-col class="autoTxt1">
          配置“{{ permissionSettingsInfo.nickName }}”相关权限
        </el-col>
        <el-col class="autoTxt1">
          已选 {{ treeSelectedCount }} 项功能
          <el-checkbox v-model="treeShowChecked" @change="showTreeNodeChange"
            >只看已选</el-checkbox
          >
        </el-col>
      </el-row>

      <el-divider />

      <el-tabs tab-position="left" style="max-height: 350px; overflow: auto">
        <el-tab-pane
          v-for="(item, index) in listAccountMenu"
          :key="index"
          :label="item.menuTypeName"
        >
          <el-tree
            :data="item.menuList"
            show-checkbox
            default-expand-all
            node-key="menuId"
            ref="tree"
            highlight-current
            :props="defaultProps"
            @check="handleNodeClick"
            :filter-node-method="filterNode"
          >
          </el-tree>
        </el-tab-pane>
      </el-tabs>

      <div
        style="
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <el-button type="primary" @click="saveAccountMenu()">确定</el-button>
        <el-button @click="permissionSettingsDialogVisibleFlag = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>

    <!--编辑用户-->
    <el-dialog
      title="编辑用户"
      :visible.sync="etidAccountDialogVisibleFlag"
      :close-on-click-modal="false"
    >
      <el-form
        :model="etidAccountForm"
        ref="etidAccountForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="关联人员" prop="employeeId">
          <el-select
            v-model="etidAccountForm.employeeId"
            placeholder="请选择关联人员"
            style="width: 100%"
          >
            <el-option
              v-for="item in this.relatedUserList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户姓名" prop="nickName">
          <el-input v-model="etidAccountForm.nickName"></el-input>
        </el-form-item>
        <el-form-item label="登录账号" prop="loginName">
          <el-input v-model="etidAccountForm.loginName"></el-input>
        </el-form-item>

        <el-form-item label="电话号码" prop="phone">
          <el-input v-model="etidAccountForm.phone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editResetForm()">重置</el-button>
        <el-button type="primary" @click="editSubmitForm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  accountManageActive,
  accountManageAdd,
  accountManagedelete,
  accountManageUpdate,
  autoCreate,
  getAccountManageMore,
  getRelatedUser,
  listAccountMenu,
  resetPwd,
  updatePwd,
  statisticInfo,
  saveAccountMenu,
} from '@/api/accountmanagement/accountmanagement';

import Pagination from '@/components/PaginationStyle1.vue';

export default {
  components: {
    Pagination,
  },

  data() {
    return {
      //查询
      onceSearch: {
        loginName: '',
        nickName: '',
        size: 10,
        current: 1,
      },

      updateDialogVisibleFlag: false,
      pwdInfo: {
        pwd: '',
        pwd2: '',
        userId: '',
      },
      //添加人员
      addAccountDialogVisibleFlag: false,
      relatedUserList: [],
      addAccountForm: {
        employeeId: '',
        nickName: '',
        loginName: '',
        phone: '',
      },
      pwdRules: {
        pwd: [
          {
            required: true,
            message: '请输入密码，至少8位，包含数字与字母',
            trigger: 'blur',
          },
          { validator: this.validatePassword, trigger: 'blur' },
        ],
        pwd2: [
          {
            required: true,
            message: '请输入密码，至少8位，包含数字与字母',
            trigger: 'blur',
          },
        ],
      },
      rules: {
        employeeId: [
          { required: true, message: '请选择关联人员', trigger: 'blur' },
        ],
        nickName: [
          { required: true, message: '请输入用户姓名', trigger: 'blur' },
        ],
        loginName: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
        ],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
      },

      //自动生成
      autoAccountDialogVisibleFlag: false,

      statisticInfo: null,
      autoCreateSuccList: [],

      //查询
      listLoading: false,
      dataList: [],
      total: 0,
      queryForm: {
        size: 10,
        current: 1,
      },
      statusTag: ['启用', '禁用'],
      statusActiveTag: ['未激活', '已激活'],

      //启用、禁用
      statusDialogVisibleFlag: false,
      switchStatusInfo: {},

      //初始化密码
      initPwdDialogVisibleFlag: false,
      initPwdInfo: {},
      initPwdSuccessDialogVisibleFlag: false,

      //删除
      delInfoDialogVisibleFlag: false,
      delInfo: {},

      //权限设置
      permissionSettingsDialogVisibleFlag: false,
      //修改权限的人
      permissionSettingsInfo: {},
      //权限数据
      listAccountMenu: {},
      //选中节点
      treeSelectedCount: 0,
      //只看已选  ,  使用临时数组 先获取所有 勾选的节点，然后通过 tree.filter 方法过滤所有节点
      treeShowChecked: false,
      //只看已选 使用 临时数组
      checkedNodeTemp: [],

      defaultProps: {
        children: 'childrenList',
        label: 'name',
      },

      //编辑用户
      etidAccountDialogVisibleFlag: false,
      etidAccountForm: {},

      pwd: '',
    };
  },
  methods: {
    validatePassword(rule, value, callback) {
      if (value.length < 8) {
        callback(new Error('密码长度至少8位'));
      } else if (!/^(?=.*[a-zA-Z])(?=.*[0-9])/.test(value)) {
        callback(new Error('密码必须包含数字和字母'));
      } else {
        callback();
      }
    },
    //查询
    async onSubmit() {
      this.listLoading = true;
      const res = await getAccountManageMore(this.onceSearch);
      const list = res.data.data.records;
      this.dataList = [...list];
      this.total = res.data.data.total;
      this.listLoading = false;
    },
    //重置查询内容
    resetSearch() {
      this.onceSearch = this.$options.data().onceSearch;

      this.queryForm = this.$options.data().queryForm;
      this.getAccountManageMore();
    },
    //添加人员
    submitForm() {
      this.$refs['addAccountForm'].validate(async (valid) => {
        if (valid) {
          let result = await accountManageAdd(this.addAccountForm);

          if (result.data.code === 200) {
            this.$message({ message: '添加成功', type: 'success' });
            this.addAccountDialogVisibleFlag = false;

            await this.getAccountManageMore();
          } else {
            this.$message.error(result.data.message);
          }
        } else {
          return false;
        }
      });
    },
    //添加人员-重置表单
    resetForm() {
      this.$refs['addAccountForm'].resetFields();
    },

    //获取关联人员
    async getRelatedUser() {
      const res = await getRelatedUser();
      // console.log(res.data.data);
      this.relatedUserList = res.data.data;
    },
    //获取查询数据
    async getAccountManageMore() {
      this.listLoading = true;
      const res = await getAccountManageMore(this.queryForm);
      const list = res.data.data.records;
      this.dataList = [...list];
      this.total = res.data.data.total;
      this.listLoading = false;
    },

    //获取状态信息
    async openAutoAccountDialog() {
      this.autoAccountDialogVisibleFlag = true;
      this.autoCreateSuccList = {};
      const res = await statisticInfo();

      if (res.data.code === 200) {
        this.statisticInfo = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    },
    //自动生成
    async autoCreate() {
      const res = await autoCreate();
      if (res.data.code === 200) {
        //重新查询状态
        await this.openAutoAccountDialog();
        this.autoCreateSuccList = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    },

    //启用、禁用 弹窗
    switchStatus(obj) {
      this.statusDialogVisibleFlag = true;
      this.switchStatusInfo = obj;
    },
    //启用、禁用 提交
    async switchStatusInfoSubmit() {
      const res = await accountManageActive(this.switchStatusInfo);
      if (res.data.code === 200) {
        this.switchStatusInfo.status =
          this.switchStatusInfo.status === 0 ? 1 : 0;
        this.statusDialogVisibleFlag = false;
      }
    },
    updatePassword(obj) {
      // console.log("mars", obj);
      this.pwdInfo = this.$options.data().pwdInfo;
      this.updateDialogVisibleFlag = true;
      this.pwdInfo.userId = obj.id;
    },
    updateSubmitForm() {
      if (this.pwdInfo.pwd != this.pwdInfo.pwd2) {
        this.$message.error('两次密码不一致！');
        return;
      }
      this.$refs['pwdInfoForm'].validate(async (valid) => {
        if (valid) {
          const res = await updatePwd(this.pwdInfo);
          if (res.data.code === 200) {
            this.updateDialogVisibleFlag = false;
            this.pwd = res.data.data;
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        } else {
          return false;
        }
      });
    },
    //打开初始化密码弹框
    initPassword(obj) {
      this.initPwdDialogVisibleFlag = true;
      this.initPwdInfo = obj;
    },
    //关闭初始化密码弹框
    initPasswordClose() {
      this.pwd = '';
      this.initPwdSuccessDialogVisibleFlag = false;
    },
    async initPwdInfoSubmit() {
      const res = await resetPwd(this.initPwdInfo);
      if (res.data.code === 200) {
        this.initPwdDialogVisibleFlag = false;
        this.initPwdSuccessDialogVisibleFlag = true;
        this.pwd = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    },
    //删除
    delInfoEvent(obj) {
      this.delInfoDialogVisibleFlag = true;
      this.delInfo = obj;
    },

    async delInfoSubmit() {
      const res = await accountManagedelete(this.delInfo);
      if (res.data.code === 200) {
        this.$message({ message: '删除成功', type: 'success' });

        let index = this.dataList.findIndex((value) => {
          return value.id === this.delInfo.id;
        });
        this.dataList.splice(index, 1);
        this.delInfoDialogVisibleFlag = false;

        //再重新请求接口
        this.getAccountManageMore();
      } else {
        this.$message.error(res.data.message);
      }
    },

    //复制到剪贴板
    copyTextToClipboard() {
      navigator.clipboard
        .writeText(this.pwd)
        .then(() => {
          this.$message({ message: '文本已复制到剪贴板', type: 'success' });
        })
        .catch((err) => {
          console.error('复制失败：', err);
        });
    },

    //权限设置
    openPermissionSettings(obj) {
      this.treeShowChecked = false;
      this.permissionSettingsInfo = obj;
      this.permissionSettingsDialogVisibleFlag = true;
      this.checkedNodeTemp = [];
      this.getListAccountMenu();
    },

    async getListAccountMenu() {
      let req = {
        id: this.permissionSettingsInfo.employeeId,
      };
      const res = await listAccountMenu(req);
      if (res.data.code === 200) {
        this.listAccountMenu = res.data.data;

        this.findChildNodeAndCheck();
      } else {
        this.$message.error(res.data.message);
      }
    },

    //遍历所有 父节点 、叶子节点  同时勾选
    findChildNodeAndCheck() {
      this.listAccountMenu.forEach((value, index) => {
        //遍历所有 叶子节点
        let allLeafNodes = this.realFindChild(value);

        //所有勾选的节点（叶子节点）
        let checkNodeList = [];
        allLeafNodes.forEach((value, index) => {
          if (value.menuStatus === 0) {
            checkNodeList.push(value);
          }
        });
        //组件 设置勾选
        this.$nextTick(() => {
          this.$refs.tree[index].setCheckedNodes(checkNodeList);
        });
        this.$nextTick(() => {
          this.getTreeNodeCount();
        });
      });
    },

    traverseAndFindLeafNodes(menuList) {
      let leafNodes = [];

      function traverse(nodes) {
        nodes.forEach((node) => {
          // 如果当前节点的childrenList为空，则它是一个叶子节点
          if (node.childrenList.length === 0) {
            leafNodes.push(node);
          } else {
            // 否则，递归遍历其子节点
            traverse(node.childrenList);
          }
        });
      }

      traverse(menuList);
      return leafNodes;
    },

    realFindChild(listNode) {
      return this.traverseAndFindLeafNodes(listNode.menuList);
    },

    //选中后改变已选数量
    handleNodeClick(data, checked, indeterminate) {
      //传递给 data 属性的数组中该节点所对应的对象   、  节点本身是否被选中 、 节点的子树中是否有被选中的节点
      // console.log(data, checked, indeterminate);
      this.getTreeNodeCount();
    },
    //修改权限
    async saveAccountMenu() {
      let reqNode = [];
      //获取 所有勾选的节点，  叶子节点+半选节点
      this.listAccountMenu.forEach((value, index) => {
        //1. 是否只是叶子节点，默认值为 false 2. 是否包含半选节点，默认值为 false
        // console.log(this.$refs.tree[index].getCheckedNodes(false, true));
        this.$refs.tree[index]
          .getCheckedNodes(false, true)
          .forEach((value, index) => {
            reqNode.push(value.menuId);
          });
      });

      let req = {
        employeeId: this.permissionSettingsInfo.employeeId,
        menuIdList: reqNode,
      };
      // console.log(req);
      //请求
      const res = await saveAccountMenu(req);
      if (res.data.code === 200) {
        this.permissionSettingsDialogVisibleFlag = false;
        this.$message({ message: '修改成功', type: 'success' });
        this.getAccountManageMore();
      } else {
        this.$message.error(res.data.message);
      }
    },

    //获取所有选中节点
    getTreeNodeCount() {
      this.treeSelectedCount = 0;
      // console.log("11");

      this.listAccountMenu.forEach((value, index) => {
        // console.log(this.$refs.tree[index].getCheckedNodes(true, true).length);
        this.treeSelectedCount += this.$refs.tree[index].getCheckedNodes(
          true,
          true
        ).length;
      });
    },
    //只看已选 状态改变
    showTreeNodeChange(value) {
      //先获取 勾选节点， 再通过 tree.filter方法 过滤所有节点
      this.checkedNodeTemp = [];
      this.listAccountMenu.forEach((value, index) => {
        this.$refs.tree[index]
          .getCheckedNodes(true, true)
          .forEach((value1, index) => {
            this.checkedNodeTemp.push(value1);
          });
      });
      this.listAccountMenu.forEach((value, index) => {
        this.$refs.tree[index].filter(value);
      });
    },
    //过滤节点
    filterNode(value, data) {
      if (this.treeShowChecked) {
        //只看已选
        return this.checkedNodeTemp.includes(data);
      } else {
        return true;
      }
    },

    //编辑用户
    editAccount(obj) {
      // console.log(obj);
      this.etidAccountForm = { ...obj };
      // this.etidAccountForm = Object.assign({},obj)
      this.etidAccountDialogVisibleFlag = true;
    },

    editResetForm() {
      this.$refs['etidAccountForm'].resetFields();
    },

    async editSubmitForm() {
      const res = await accountManageUpdate(this.etidAccountForm);
      this.etidAccountDialogVisibleFlag = false;
      if (res.data.code === 200) {
        this.$message({ message: '修改成功', type: 'success' });
        //再重新请求接口
        await this.getAccountManageMore();
      } else {
        this.$message.error(res.data.message);
      }
    },
  },

  created() {
    this.getRelatedUser();
    this.getAccountManageMore();
  },
};
</script>

<style scoped lang="scss">
.accountListBody {
  width: 100%;
  height: 100%;
  padding: 24px;
  overflow: hidden;
  overflow-y: auto;
}

.autoTxt1 {
  text-align: center;
  font-size: 20px;
}

.tableContainer {
  background-color: antiquewhite;
  width: 100%;
  margin-top: 20px;
}
</style>
